import { Loading } from '@livecontrol/core-ui';
import { assert } from '@sindresorhus/is';
import { Children, useEffect } from 'react';
import type { PropsWithChildren, ReactElement } from 'react';
import type { Token } from '../model';
import { store } from './factory';
import { Store } from './store';

const Me = ({ token, children }: PropsWithChildren<{ token: Token }>): ReactElement => {
  const actual = store((state: Store.State) => state.me);

  // Look up the record for the authenticated user
  const { user, error } = Store.User.useUser(token.user);

  // Did we determine who we are?
  useEffect(() => {
    store.produce((draft: Store.Draft) => {
      draft.me = user;
    });
  }, [user]);

  // Did an error occur?
  useEffect(() => {
    if (error) {
      // Reset the store (will route back to `/login`)
      Store.User.logout();
    }
  }, [error]);

  // Spin until we know who are
  if (!actual) {
    return (
      <div
        className='d-flex align-items-center justify-content-center w-full'
        style={{ height: '100vh', width: '100vw' }}
      >
        <Loading.Delay />
      </div>
    );
  }

  assert.object(actual);

  return <>{Children.toArray(children)}</>;
};

export const Reactor = ({ children }: PropsWithChildren<unknown>): ReactElement => {
  // Get the authentication token
  const token = store((state: Store.State) => state.token);

  return token ? <Me token={token}>{children}</Me> : <>{Children.toArray(children)}</>;
};
